// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"593":"VoltoFormBlockView","1248":"PersonAgenda","6346":"VoltoFormBlockEdit","6454":"Widgets","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"593":"138ef16b","1248":"1daf7ad1","6346":"62d8ace4","6454":"ac119948","7051":"ac119948"}[chunkId] + ".chunk.css";
};